import { Component, OnInit } from '@angular/core';
import { Title }     from '@angular/platform-browser';
import { LangService } from 'src/app/services/lang/lang.service';
import { WinService } from 'src/app/services/win.service'; 
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { ApproveartworkComponent } from 'src/app/components/modals/approveartwork/approveartwork.component';
import { CancelartworkComponent } from 'src/app/components/modals/cancelartwork/cancelartwork.component';
import { MessageComponent } from 'src/app/components/modals/message/message.component'
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { OrderService } from 'src/app/services/api/order.service';
import { ProductService } from 'src/app/services/api/product.service';

@Component({
	selector: 'app-reviewartwork',
	templateUrl: './reviewartwork.component.html',
	styleUrls: ['./reviewartwork.component.scss']
})
export class ReviewartworkComponent implements OnInit {

	orderId: any = null;
	qouteItemId: any = null;

	enabledEditQty: boolean = false;
	qty: any = 100;
	item: any = null;
	order: any = null;
	product: any = null;

	private modalRef : BsModalRef;

	constructor(
		public winService : WinService,
		public lang : LangService,
		public title : Title,
		public sessionService : SessionService,
		public router : Router,
		public activeRoute: ActivatedRoute,
		public orderService : OrderService,
		public productService: ProductService,
		public modalService: BsModalService
	) { }

	ngOnInit() {
		this.router.navigate(['/']);

		// this.title.setTitle('Review Artwork');
		// if(!this.sessionService.user.isLogedIn){
		// 	this.router.navigate(['/']);
		// } 
		// this.activeRoute.paramMap.subscribe( urlParam => {
		// 	this.orderId = urlParam.get('orderId');
		// 	this.qouteItemId = urlParam.get('quoteItemId');

		// 	if(!this.orderId || !this.qouteItemId){
		// 		this.router.navigate(['/']);
		// 	}

		// 	this.orderService.getOrder(this.orderId).then(order => {
		// 		if(order){
		// 			let o: any = order;
		// 			let sd: any = o.shipping_description.split(' - ');
		// 			o.shipping_description2 = o.shipping_description;
		// 			if(typeof sd[0] != 'undefined'){
		// 				o.shipping_description2 = sd[0];
		// 			}
		// 			this.order = o;

		// 			if(this.order.status == 'canceled'){
		// 				this.orderService.toastService.add(this.lang.getLang('l95a'), 'info');
		// 				this.router.navigate(['/my/order/'+this.orderId+'/summary']);
		// 			} else {
		// 				o.items.forEach(item => {

		// 					if(item.sku.match(/custom-t-shirt/gi)){
		// 						item.sku = 'custom-t-shirt';
		// 						item.parent_item = item;
		// 					}
		// 					if(item.sku.match(/custom-canvas-tote-bag/gi)){
		// 						item.sku = 'custom-canvas-tote-bag';
		// 						item.parent_item = item;
		// 					}

		// 					if(item.parent_item){
		// 						if(item.parent_item.quote_item_id == this.qouteItemId){

		// 							let attachUrl = '/rest/entrelable/V1/lns-orderattachment/attachment/' + item.parent_item.quote_item_id
		// 							this.orderService.makeRequest(attachUrl, '', 'GET').then(attach => {
		// 								if(attach && typeof attach[0] != 'undefined'){

		// 									let attch: any = attach[0];
		// 									if(attch.id){
		// 										item.attachment = attach[0];
		// 										item.parent_item.discounted_price_pp = item.parent_item.base_price - ( item.parent_item.base_price * (item.parent_item.discount_percent/100));
		// 										item.parent_item.discounted_price_pp = parseFloat(item.parent_item.discounted_price_pp.toFixed(2));

		// 										if(item.attachment.others.admin_attachment){

		// 											let sku = item.sku;
		// 											sku = sku.replace('-' + item.name, '');
		// 											this.productService.getProductBySku(sku).then(perProd => {
		// 											let product: any = perProd;
		// 											item['product'] = product;

		// 											let custom_options = item.parent_item.product_option.extension_attributes.custom_options

		// 											let opts = product.options;
		// 											opts.forEach(opt => {
		// 												if(opt.title == 'custom size'){
		// 													custom_options.forEach(co => {
		// 														if(opt.option_id == co.option_id){
		// 															let coSize = co.option_value.split(' x ');
		// 															if(coSize.length == 2){
		// 																item.parent_item['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
		// 															}
		// 														}
		// 													});
		// 												}
		// 											});
													

		// 											if(typeof item.parent_item['additional_data'] != 'undefined'){
		// 												try {
		// 													item.parent_item['additional_data'] = JSON.parse(item.parent_item['additional_data']);
		// 													item.parent_item['additional_data']['sticker_pad'] = item.parent_item['additional_data']['sticker_pad'] + ''; /** make string */
		// 												} catch (error) {
		// 													/** do nothing */
		// 												}
		// 											}

		// 											item['custom_options'] = [];
		// 											custom_options.forEach((option, key) => {
		// 												opts.forEach(opt => {
		// 													if(parseInt(option.option_id) == opt.option_id){
		// 														if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
		// 															custom_options[key]['title'] = opt.title;
		// 															if(opt.title == 'Color'){
		// 																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
		// 																custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
		// 																custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 															else if(opt.title == 'Print Location'){
		// 																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 															else if(this.productService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
		// 																if(custom_options[key]['option_value']){
		// 																	custom_options[key]['title']  = opt.title.replace('-', ' Qty ');
		// 																	item['custom_options'].push(custom_options[key]);
		// 																}
		// 															}
		// 															else if(this.productService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
		// 																custom_options[key]['title']  = opt.title;
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 														}
		// 														else if(opt.product_sku == 'custom-canvas-tote-bag'){
		// 															custom_options[key]['title'] = opt.title;
			
		// 															if(opt.title == 'Sizes' || opt.title == 'Print Location'){
		// 																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 															else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 														}
		// 														else {
		// 															if(opt.title == 'custom size'){
		// 																custom_options[key]['title'] = 'size';
		// 																let coSize = custom_options[key]['option_value'].split(' x ');
		// 																if(coSize.length == 2){
		// 																	custom_options[key]['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
		// 																}
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 															else if(opt.title == 'adhesive'){
		// 																custom_options[key]['title'] = opt.title;
		// 																item['custom_options'].push(custom_options[key]);
		// 															}
		// 															else if(opt.title == 'cutting type'){
		// 																custom_options[key]['title'] = opt.title;
		// 																item['custom_options'].push(custom_options[key]);
		// 																opt.values.forEach(optVal => {
		// 																	if(optVal.option_type_id + '' == custom_options[key]['option_value']){
		// 																		custom_options[key]['option_value'] = optVal.title;
		// 																	}
		// 																});
		// 															}
		// 														}
		// 													}
		// 												});
		// 											});

		// 											this.productService.getProductImage(product.id, 150, 150).then(pImage => {
		// 												if(pImage){
		// 												item.parent_item['images'] = pImage;
		// 												}
		// 											});
													
		// 											this.product = product;
		// 											});

		// 											this.item = item;
		// 										} else {
		// 											this.orderService.toastService.add(this.lang.getLang('l106a'), 'info');
		// 											this.router.navigate(['/my/order/'+this.orderId+'/summary']);
		// 										}

		// 									} else {
		// 										this.orderService.toastService.add(this.lang.getLang('l105a'), 'info');
		// 										this.router.navigate(['/my/order/'+this.orderId+'/summary']);
		// 									}
		// 								}
		// 							});
		// 						}
		// 					}
		// 				});
		// 			}
		// 		} else {
		// 			this.router.navigate(['/']);
		// 		}
		// 	});
		// });
	}

	getOptionValueTitle(opt:any, co:any){
		let title = [];
		opt.values.forEach(optValue => {
			let coOptionValues = co.option_value.split(',');
			coOptionValues.forEach(coOptionValue => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

  enableEditQuantity(){
    this.enabledEditQty = true;
  }
  
  confirmQty(){
    this.enabledEditQty = false;
    /* the rest of the function to save quantity */
  }

  adjustQty(op){
    if(op == 'minus'){
      this.qty--;
    }else{
      this.qty++;
    }
  }

  get isApproved() {
    this.item.attachment.approved
    let approved = false;
    if(this.item){
      if(this.item.attachment) {
        if(this.item.attachment.approved == 'yes') {
          approved = true;
        }
      }
    }

    return approved;
  }

  approveArtwork(){
    this.modalRef = this.modalService.show(ApproveartworkComponent);
    this.modalRef.setClass('modal-dialog-centered modal-lg');
    this.modalRef.content.closeBtnName = 'Close';

    this.modalRef.content.onClose = () => {
        this.modalRef.hide();
    };

    this.modalRef.content.onAgree = () => {
      	this.approveArtworkHelper().then(approved => {
      		this.modalRef.hide();
      	});
    }
  }

  approveArtworkHelper(){
    if(this.item.attachment){
      let url = '/rest/entrelable/V1/lns-orderattachment/attachment/approve/' + this.order.entity_id + '/' + this.item.attachment.id;
      return new Promise(res => {
        this.orderService.setLoader(true);
        this.orderService.makeRequest(url, '', 'POST').then(approved => {
          if(approved){
            let a: any = approved[0];

            this.item.attachment.approved = a.approved;
            this.orderService.toastService.add(this.lang.getLang('l91a'), 'success');
          }
          res(approved);
          this.orderService.setLoader(false);
        });
      });
    }
  }

  cancelArtwork(){
    let config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {
        item: this.item,
        order: this.order,
        product: this.product
      }
    };

    this.modalRef = this.modalService.show(CancelartworkComponent, config);
    this.modalRef.setClass('modal-dialog-centered modal-lg');
    this.modalRef.content.closeBtnName = 'Close';

    this.modalRef.content.onClose = () => {
        this.modalRef.hide();
    };

    this.modalRef.content.onCancel = reason => {
      /* the rest of the code */
      this.cancelArtworkHelper(reason);
      this.modalRef.hide();
    }
  }

  cancelArtworkHelper(reason){
    let attachUrl = '/rest/entrelable/V1/lns-api/sales/order/'+this.order.entity_id+'/cancel/request';
    let jsonData = {
      "message": reason,
      "others" : {
        "item_id": this.item.item_id
      }
    }
    this.orderService.setLoader(true);
    this.orderService.makeRequest(attachUrl, jsonData, 'POST').then(cancelReq => {
      let cr:any = cancelReq;
      if(cr[0]){
        if(cr[0].id){
          this.orderService.toastService.add(this.lang.getLang('l94a'), 'success');
        }
      }
      this.orderService.setLoader(false);
    });
  }

  requestChanges(){
    const config: ModalOptions = {
        initialState: {
          quote_id: this.order.quote_id,
          qouteItemId: this.qouteItemId,
          order: this.order,
          item: this.item,
        }
      };
    let initialState = {}
    this.modalRef = this.modalService.show(MessageComponent, config);
    this.modalRef.setClass('modal-dialog-centered modal-lg');
    this.modalRef.content.closeBtnName = 'Close';

    this.modalRef.content.onClose = () => {
        this.modalRef.hide();
    };

    this.modalRef.content.onMessageSent = () => {
      /* the rest of the code */
      this.modalRef.hide();
    }
  }
  
  

}
